import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
import { ErrorBanner } from '../../common';
import { ErrorBannerProps } from '../types';


export const CookiesVideosWarningBanner  = (
    { bannerLabel,
        buttonLabel,
        bannerDescLabel,
    }:ErrorBannerProps) => {

    return (
        <div data-testid="cookie-warning-message">
            <ErrorBanner
                heading={bannerLabel}
                variant="warning"
                buttonProp={{
                    buttonText: buttonLabel,
                    className: 'text-nowrap ot-sdk-show-settings',
                    slot: 'after',
                    type: 'button'
                  }}
            >
                <>
                    {bannerDescLabel}
                    <CatIconWarningTriangle slot="before" />
                </>
            </ErrorBanner>
        </div>
    );
};

export default CookiesVideosWarningBanner;
